import { post } from '../request';
import { APP_CONFIG } from '../../config';
import type { StorageboxData } from '../../@types/storagebox';

export const registerStoragebox = async (formData: StorageboxData) => {
  return await post(
    `${APP_CONFIG.baseApiUrl}/konto/api/client/products/lagerboxes/register`,
    { ...formData },
    'XSRF-TOKEN',
  );
};
